import { render, staticRenderFns } from "./vue-flow-editor-preview.vue?vue&type=template&id=afad7470&"
import script from "./vue-flow-editor-preview.vue?vue&type=script&lang=js&"
export * from "./vue-flow-editor-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports